import React from 'react';

import { Grid, Section, HelpOutlineIcon, Tooltip } from '@gogame/components';
import { FormField, withForm, SidePageV2 } from '@gogame/form';

import { loadReIds } from 'scenes/Applications/sources/fields';

import { ApplicationREField } from './components/ApplicationREField';
import {
  DAYS,
  RES,
  IMPRESSION,
  CLICK,
  RECURRING,
  RE_ENGAGEMENT,
} from './constants';
import { appsSchema } from './schemas';

const ApplicationForm = withForm({
  validationSchema: appsSchema,
})(({
  onClose,
  onExited,
  open,
  title,
  subTitle,
  entityId,
  loading,
  setFieldValue,
}) => {
  const handleBlur = ({ target }) => {
    if (!target.value) {
      setFieldValue(target.name, 0);
    }
  };
  return (
    <SidePageV2
      onClose={onClose}
      onExited={onExited}
      open={open}
      loading={loading}
      size={'lg'}
    >
      <SidePageV2.Title title={title} subTitle={subTitle} entityId={entityId} />
      <SidePageV2.NewBody>
        <Section title={'Inactivity window'}>
          <Grid container spacing={2}>
            <Grid item container spacing={2}>
              <Grid item xs={3}>
                <FormField.TextField
                  label={'Inactivity period'}
                  padding={0}
                  name={DAYS}
                  type={'days'}
                  helper={'Period for launching RE campaigns after this period'}
                  placeholder={'0'}
                  onBlur={handleBlur}
                />
              </Grid>
              <Grid item xs={3}>
                <FormField.TextField
                  label={'Impression attribution'}
                  padding={0}
                  name={IMPRESSION}
                  type={'days'}
                  placeholder={'0'}
                  onBlur={handleBlur}
                />
              </Grid>
              <Grid item xs={3}>
                <FormField.TextField
                  label={'Click attribution'}
                  padding={0}
                  name={CLICK}
                  type={'days'}
                  placeholder={'0'}
                  onBlur={handleBlur}
                />
              </Grid>
              <Grid item xs={3}>
                <FormField.TextField
                  label={'Days between remarketing'}
                  padding={0}
                  name={RECURRING}
                  type={'days'}
                  placeholder={'0'}
                  onBlur={handleBlur}
                />
              </Grid>
            </Grid>
            <Grid item container xs={12} alignItems={'center'}>
              <Grid item={3}>
                <FormField.Checkbox
                  name={RE_ENGAGEMENT}
                  label={'Track RE'}
                  padding={'0'}
                />
              </Grid>
              <Grid item>
                <Tooltip
                  title={
                    'Following settings will put new Affiliate to the chosen state'
                  }
                  wrapper
                  wrapperComponent={'div'}
                  wrapperZeroMinWidth
                >
                  <HelpOutlineIcon color={'action'} sx={{ fontSize: 16 }} />
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
        </Section>
        <Section
          title={'Campaigns RE Settings'}
          subTitle={
            'Default value for the "Track RE" flag when creating a campaign'
          }
          fullHeight={true}
        >
          <ApplicationREField name={RES} source={loadReIds} />
        </Section>
      </SidePageV2.NewBody>
      <SidePageV2.Actions>
        <SidePageV2.CloseButton />
        <SidePageV2.SubmitButton />
      </SidePageV2.Actions>
    </SidePageV2>
  );
});

export default ApplicationForm;
